import { render, staticRenderFns } from "./WdfStudentInformation.vue?vue&type=template&id=a37e315e"
import script from "./WdfStudentInformation.vue?vue&type=script&lang=js"
export * from "./WdfStudentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports